import { create } from 'zustand';
import type { ColorScheme } from './colorSchemes';
import { DEFAULT_SCHEME } from './colorSchemes';

type ThemeState = {
  scheme: ColorScheme;
  setScheme: (s: ColorScheme) => void;
};

export const useColorScheme = create<ThemeState>((set) => ({
  scheme: DEFAULT_SCHEME,
  setScheme: (scheme) => set({ scheme }),
}));

export const applySchemeToDocument = (scheme: ColorScheme) => {
  const root = document.documentElement;
  root.setAttribute('data-theme', scheme);
};


